// extracted by mini-css-extract-plugin
export default {"root":"styles-scoped__root--tIIcC","wraper":"styles-scoped__wraper--cqLiu"};